import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent{
  username: string;
  password: string;
  public error_message = '';
  constructor(private router: Router, private route: ActivatedRoute) {
  }

  public enterPage() {
    this.router.navigate(['visor'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/home/home.component.ts